import { render, staticRenderFns } from "./tuijianyijian.vue?vue&type=template&id=330663e0&scoped=true&"
import script from "./tuijianyijian.vue?vue&type=script&lang=ts&"
export * from "./tuijianyijian.vue?vue&type=script&lang=ts&"
import style0 from "./tuijianyijian.vue?vue&type=style&index=0&id=330663e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330663e0",
  null
  
)

export default component.exports